// material-ui
import { withStyles } from "@material-ui/core/styles";
// custom
import Table from "components/Table";
import ProgramCount from "hooks/ProgramCount";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class MusicalFamiliesList extends Component {
  static propTypes = {
    // classes: PropTypes.object,
    musicalFamilies: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedMusicalFamily, index) {
    const { onSelect } = this.props;
    if (onSelect) {
      onSelect(selectedMusicalFamily, index);
    }
  }

  render() {
    const { musicalFamilies } = this.props;

    return (
      <Table
        data={musicalFamilies}
        meta={[
          {
            path: "name",
            title: "Name",
          },
          {
            path: "programCount",
            title: "Programs#",
            render: (t, d) => (
              <ProgramCount
                value={t}
                id={d.id}
                title={`${d.name} related programs`}
                type="musicalFamilies"
              />
            ),
          },
        ]}
        onRowSelect={this.onSelect.bind(this)}
      />
    );
  }
}

export default withStyles(styles)(MusicalFamiliesList);
